import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { JProject } from '@ascschool/interface/project';
import { ButtonType } from '@ascschool/interface/setting';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { AuthService } from '@ascschool/core/auth/auth.service';
import {  ShortcutInput } from 'ng-keyboard-shortcuts';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzUploadChangeParam } from 'ng-zorro-antd/upload';

interface DataItem {
  stt: number;
  maHS: string;
  hoDem: string;
  ten: string;
  m1: number;
  m2: number;
  m3: number;
  p1: number;
  p2: number;
  p3: number;
  p4: number;
  v1: number;
  v2: number;
  th1: number;
  diemtkhk: number;
  tamtinhdtb: number;
  dtb: number;
}

@Component({
  selector: 'app-sample2',
  templateUrl: './sample2.component.html',
  styleUrls: ['./sample2.component.scss']
})
export class Sample2Component implements OnInit, AfterViewInit {
  viewHeight: number;
  private elementPageExpandedSearch: ElementRef;
  @ViewChild('pageOptionBtnGroup', { static: false }) elementpageOptionBtnGroup: ElementRef;
  @ViewChild('pageSearch', { static: false }) elementPageSearch: ElementRef;
  @ViewChild('pageHeaderTable') elementPageHeaderTable: ElementRef;
  @ViewChild('pageHeaderTable2') elementPageHeaderTable2: ElementRef;
  @ViewChildren('inputs') inputs;
  @ViewChild('pageExpandedSearch', { static: false }) set content(content: ElementRef) {
    if (content) {
      // initially setter gets called with undefined
      this.elementPageExpandedSearch = content;
    }
  }
  show = false;
  maxHeight: number;
  height: number;
  width: number;
  heightPopup: number;
  contentHeight: number;
  canSave: boolean;
  rowMax: number = 24;
  colMax: number = 10;
  columns: any;
  rows: any;
  keyUpCode: number = 38;
  ketDownCode: number = 40;
  keyLeftCode: number = 37;
  keyRightCode: number = 39;
  listOfData: DataItem[] = [
    {
      stt: 1,
      maHS: '1900177326',
      hoDem: 'Dương Thị Thùy',
      ten: 'Anh',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 2,
      maHS: '1900177327',
      hoDem: 'Ngô Phương',
      ten: 'Anh',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 3,
      maHS: '1900177328',
      hoDem: 'Tống Duy',
      ten: 'Anh',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 4,
      maHS: '1900177332',
      hoDem: 'Bùi Xuân',
      ten: 'Đảm',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 5,
      maHS: '1900177333',
      hoDem: 'Hoàng Ngọc',
      ten: 'Đạt',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 6,
      maHS: '1900177334',
      hoDem: 'Ngô Duy',
      ten: 'Đông',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 7,
      maHS: '1900177329',
      hoDem: 'Lê Đăng',
      ten: 'Dũng',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 8,
      maHS: '1900177330',
      hoDem: 'Nguyễn Trọng',
      ten: 'Dũng',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 9,
      maHS: '1900177331',
      hoDem: 'Ngô Thị',
      ten: 'Duyên',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 10,
      maHS: '1900177335',
      hoDem: 'Nguyễn Thị Hương',
      ten: 'Giang',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 11,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 12,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hiền',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 13,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Vui',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 14,
      maHS: '1900177336',
      hoDem: 'Lê Công',
      ten: 'Định',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 15,
      maHS: '1900177336',
      hoDem: 'Nguyễn Vũ',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 16,
      maHS: '1900177336',
      hoDem: 'Lê Bằng',
      ten: 'Quang',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 17,
      maHS: '1900177336',
      hoDem: 'Đàm Vĩnh',
      ten: 'Hưng',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 18,
      maHS: '1900177336',
      hoDem: 'Dương Trinh Bửu',
      ten: 'Ngọc',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 19,
      maHS: '1900177336',
      hoDem: 'Liên Văn Thánh',
      ten: 'Giá',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 20,
      maHS: '1900177336',
      hoDem: 'Ninh Dương Lan',
      ten: 'Ngọc',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 21,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 22,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 23,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 24,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    },
    {
      stt: 25,
      maHS: '1900177336',
      hoDem: 'Dương Thị Khánh',
      ten: 'Hà',
      m1: null,
      m2: null,
      m3: null,
      p1: null,
      p2: null,
      p3: null,
      p4: null,
      v1: null,
      v2: null,
      th1: null,
      diemtkhk: null,
      tamtinhdtb: null,
      dtb: null
    }
  ];
  displayedColumns: string[];
  dataSource: any[] = [];
  editId: string | null = null;
  validateForm!: FormGroup;
  project: JProject;
  btnType: ButtonType;
  buttonTypeEnum = ButtonType;
  inndexInput: number[] = [];
  shortcuts: ShortcutInput[] = [];
  get breadcrumbs(): string[] {
    return ['THPT', 'Lớp học'];
  }
  constructor(
    private msg: NzMessageService,
    private fb: FormBuilder,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    private authQuery: AuthQuery,
    private renderer: Renderer2,
    private message: NzMessageService,
  ) {}

  ngOnInit() {
    this.canSave = true;
    this.maxHeight = window.innerHeight;
    this._authService.getNavChangeEmitter().subscribe((item) => {
      setTimeout(() => {
        this.height = this.caculateHeight(this.maxHeight);
        this.width = this.caculateWidth();
      }, 1);
    });
    this.validateForm = this.fb.group({
      khoiLop: [null],
      lopHoc: [null],
      monHoc: [null]
    });
    this.authQuery.userSetting$.subscribe(type => {
      if (type){
        this.btnType = type.btnType;
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.height = this.caculateHeight(this.maxHeight);
      this.width = this.caculateWidth();
    }, 1);
    this.cdRef.detectChanges();
    //keyboard
    this.shortcuts.push(
      {
        key: ["ctrl + s"],
        label: "Help",
        description: "Cmd + b",
        command: (e) => this.save(),
        preventDefault: true
      }
    );
  }
  handleChange(info: NzUploadChangeParam): void {
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      this.msg.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      this.msg.error(`${info.file.name} file upload failed.`);
    }
  }
  submitForm(): void {
    // tslint:disable-next-line: forin
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
  }
  save(): void {
    this.message.create('success', `Lưu điểm thành công`);
  }
  resetForm(): void {
    this.validateForm.reset();
  }
  sortNameFn = (a: DataItem, b: DataItem) => a.ten.localeCompare(b.ten);

  startEdit(id: string): void {
    this.editId = id;
  }

  stopEdit(): void {
    this.editId = null;
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  enterMark(value: any) {
    if (value != null && value !== '') {
      value = value.replace('.', '');
      value = value.replace(',', '');
      // tslint:disable-next-line: radix
      if (parseInt(value.slice(0, 1)) === 0) {
        value = value.slice(0, 1) + '.' + value.slice(1);
        // tslint:disable-next-line: radix
      } else if (parseInt(value) > 10) {
        value = value.slice(0, 1) + '.' + value.slice(1);
      }
    }
    return value;
  }
  focusInput(rowIdx: number, colIdx: number) {
    if (rowIdx <= this.rowMax && colIdx < this.colMax) {
      const inputEls = this.inputs.toArray();
      const flatIdx = rowIdx * this.colMax + colIdx;
      inputEls[flatIdx].nativeElement.focus();
    }
  }
  shiftFocusDown(rowIdx, colIdx) {
    if (rowIdx < this.rowMax) {
      this.focusInput(rowIdx + 1, colIdx);
    } else if (rowIdx === this.rowMax && colIdx < this.colMax) {
      this.focusInput(0, colIdx + 1);
    }
  }
  shiftFocusUp(rowIdx, colIdx) {
    if (rowIdx > 0) {
      this.focusInput(rowIdx - 1, colIdx);
    }
  }
  shiftFocusRight(rowIdx, colIdx) {
    this.focusInput(rowIdx, colIdx + 1);
  }
  shiftFocusLeft(rowIdx, colIdx) {
    this.focusInput(rowIdx, colIdx - 1);
  }
  onResize() {
    this.maxHeight = window.innerHeight;
    this.width = this.caculateWidth();
    this.height = this.caculateHeight(this.maxHeight);
  }
  caculateHeight(maxheight: number): number {
    let settings = this._authService.getSettingInfo();
    let heightOptionBtnGroup: number = this.elementpageOptionBtnGroup.nativeElement.offsetHeight;
    let heightSearch: number = this.elementPageSearch.nativeElement.offsetHeight;
    let elementPageHeaderTable: number = this.elementPageHeaderTable.nativeElement.offsetHeight;
    let elementPageHeaderTable2: number = this.elementPageHeaderTable2.nativeElement.offsetHeight;
    let heightContentPaddingtop: number = 16;
    let heightContentPaddingbottom: number = 16;
    let heightPagnagation: number = 0;
    let heightMenu = 0;
    let heightInfo = 0;
    return (
      maxheight -
      heightOptionBtnGroup -
      heightSearch -
      elementPageHeaderTable -
      heightPagnagation -
      elementPageHeaderTable2 -
      heightContentPaddingtop -
      heightContentPaddingbottom -
      heightMenu -
      heightInfo
    );
  }
  caculateWidth() {
    let widthPage: number = this.elementPageSearch.nativeElement.offsetWidth;
    if (widthPage < 1200) {
      return 1200;
    } else if (widthPage < 1500) {
      return 1500;
    } else if (widthPage < 1800) {
      return 1800;
    }
  }
  onFocus(rowIdx: number, colIdx: number){
    if (rowIdx <= this.rowMax && colIdx < this.colMax) {
      const inputEls = this.inputs.toArray();
      const flatIdx = rowIdx * this.colMax + colIdx;
      setTimeout(() => {
        this.changeColorInput(this.inndexInput, 'rgba(0, 0, 0, 0.85)');
        this.renderer.listen(inputEls[flatIdx].nativeElement, 'paste', (event) => {
          this.pasteData(event, rowIdx, colIdx, inputEls[flatIdx].nativeElement);
        });
      }, 1);
    }
  }
  pasteData(event: ClipboardEvent, rowId: number, colId: number, inputPaste: any) {
    event.preventDefault();
    this.inndexInput = [];
    const maxCol = Object.keys(this.listOfData[rowId]).length - 3;
    const maxRow = Object.keys(this.listOfData).length;

    const clipboardData = event.clipboardData;
    const pastedText = clipboardData.getData("text");
    // tslint:disable-next-line: variable-name
    const row_data = pastedText.split("\n");
    let rowIndex = rowId;
    this.displayedColumns = row_data[0].split("\t");
    delete row_data[row_data.length - 1];
    // Create table dataSource
    row_data.forEach(rowData => {
      const row = {};
      let colIndex = colId + 4;
      this.displayedColumns.forEach((a, index) => {
        if (colIndex < maxCol && rowIndex < maxRow){
          const rowSelected = this.listOfData[rowIndex];
          const key = Object.keys(this.listOfData[rowIndex])[colIndex];
          row[a] = rowData.split('\t')[index];
          rowSelected[key] = row[a];
          colIndex += 1;
          const flatIdx = rowIndex * this.colMax + colIndex - 5;
          this.inndexInput.push(flatIdx);
        }
      });
      rowIndex += 1;

    });
    this.changeColorInput(this.inndexInput, '#ff4500', '#dfeafb');
    inputPaste.blur();
    this.onChange(1);
  }
  changeColorInput(arrIndex: number[], color: string, backgroundColor?: string){
    arrIndex.forEach(flatIdx => {
      const inputEls = this.inputs.toArray();
      inputEls[flatIdx].nativeElement.style.color = color;
      if (backgroundColor !== undefined){
        inputEls[flatIdx].nativeElement.style.background = backgroundColor;
      }else{
        inputEls[flatIdx].nativeElement.style.background = '#fff';
      }
    });
  }
  onChange(event: any){
    if (event !== ''){
      this.canSave = false;
    }else{
      this.canSave = true;
    }
  }
}
